import React, { type ReactNode } from 'react';

import { styled as styled2 } from '@compiled/react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import Avatar from '@atlaskit/avatar';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import type { IntlShape } from '@atlassian/jira-intl';

import type { ComponentUser } from '../../../../common/model';
import messages from './messages';

type Props = {
	user?: ComponentUser;
	intl: IntlShape;
};

export default function LeadView(props: Props) {
	const { formatMessage } = props.intl;

	if (!props.user) {
		return null;
	}

	const { avatarUrl, displayName, profileUrl, active } = props.user;

	return (
		<Link href={profileUrl} data-test-id="project-directories.components.table.cell.lead.link">
			<Wrapper>
				<AvatarContainer>
					<Avatar src={avatarUrl} size="small" key="avatar" />
				</AvatarContainer>
				{active === true
					? displayName
					: // @ts-expect-error - TS2769: No overload matches this call.
						formatMessage(messages.deactivated, {
							userName: displayName,
							status: (text: string[]): ReactNode => <UserStatus>{text[0]}</UserStatus>,
						})}
			</Wrapper>
		</Link>
	);
}

// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: {
		display: 'inline-block',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Link = styled2.a({
	display: 'inline-block',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarContainer = styled2.div({
	// TODO Delete this comment after verifying space token -> previous value ``${gridSize}px``
	paddingRight: token('space.100', '8px'),
	display: 'flex',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserStatus = styled2.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N200),
});
